document.addEventListener("DOMContentLoaded", function() {
  const modal = document.getElementById("globalCtaModal");
  const form = document.getElementById("globalCtaForm");
  const message = document.getElementById("globalFormMessage");
  const heading = document.getElementById("modalHeading");

  const fieldMap = {
    "awarenessform": ["email"],
    "considerationform": ["email","fullname","business_name","zip_code"],
    "conversionform": ["email","fullname","business_name","zip_code","role","num_crews","products"],
    "contactform": ["email","fullname","company","zip_code","role","products","request_type","message","opt_in"]
  };

  let currentType = "awarenessform"; // default

  // Open modal
  document.querySelectorAll(".cta-trigger").forEach(btn => {
    btn.addEventListener("click", () => {
      currentType = btn.dataset.ctaType || "awarenessform"; // 👈 take from attribute
      heading.textContent = btn.textContent;
      buildForm(currentType);
      modal.classList.remove("hidden");
    });
  });

  // Close modal
  modal.querySelector(".modal__close-button").addEventListener("click", () => {
    modal.classList.add("hidden");
  });

  function buildForm(type) {
    form.innerHTML = ""; // reset
    fieldMap[type].forEach(field => {
      if (field === "products") { 
        form.innerHTML += `           
          <div class="field product-interest">
              <label class="field__label"></label>
              <select name="products" class="field__input" required>
              <option value="OptimusZ">OptimusZ</option>
              <option value="OPTIMUS ATM">OPTIMUS ATM</option>
              <option value="OPTIMUS Chainsaws">OPTIMUS Chainsaws</option>
              <option value="OPTIMUS Trimmers & Edgers">OPTIMUS Trimmers & Edgers</option>
              <option value="OPTIMUS Blowers">OPTIMUS Blowers</option>
              <option value="OPTIMUS Hedge Trimmers">OPTIMUS Hedge Trimmers</option>
              <option value="OPTIMUS Charging Solutions">OPTIMUS Charging Solutions</option>
              <option value="OPTIMUS Batteries & Chargers">OPTIMUS Batteries & Chargers</option>
              <option value="OPTIMUS Specialty">OPTIMUS Specialty</option>
              <option value="OPTIMUS Accessories">OPTIMUS Accessories</option>
              <option value="Utility Vehicles">Utility Vehicles</option>
              <option value="Residential Vehicles">Residential Vehicles</option>
              <option value="Lawn Mowers">Lawn Mowers</option>
              <option value="Chainsaws">Chainsaws</option>
              <option value="Leaf Blowers">Leaf Blowers</option>
              <option value="Trimmers & Edgers">Trimmers & Edgers</option>
              <option value="Hedge Trimmers">Hedge Trimmers</option>
              <option value="Snow Throwers">Snow Throwers</option>
              <option value="Specialty">Specialty</option>
              <option value="Robotic Lawn Mowers">Robotic Lawn Mowers</option>
              <option value="Attachments & Accessories">Attachments & Accessories</option>
              <option value="Batteries & Chargers">Batteries & Chargers</option>
              <option value="Pressure Washers">Pressure Washers</option>
            </select>
          </div>`;
      } else if (field === "request_type") {
          form.innerHTML += `
            <div class="field">
              <label class="field__label">Request Type *</label>
              <select name="request_type" class="field__input" required>
                <option value="">-- Select --</option>
                <option value="support">Support</option>
                <option value="demo request">Demo Request</option>
                <option value="product questions">Product Questions</option>
                <option value="dealer support">Dealer Support</option>
                <option value="other">Other</option>
              </select>
            </div>`;
        } else if (field === "message") {
          form.innerHTML += `
            <div class="field">
              <textarea name="message" class="field__input" required></textarea>
              <label class="field__label">Message *</label>
            </div>`;
        } else if (field === "opt_in") {
          form.innerHTML += `
            <div class="field">
              <label>
                <input type="checkbox" name="opt_in" value="true" required>
                I agree to receive emails *
              </label>
            </div>`;
        } else {
        // Labels for other fields
        let label = field.replace("_", " ").replace(/\b\w/g, c => c.toUpperCase());

        // Special case: num_crews → Number of Crews
        if (field === "num_crews") {
          label = "Number of Crews";
        }
        form.innerHTML += `
          <div class="field">
            <input type="text" name="${field}" class="field__input" ${["email","fullname","business_name"].includes(field) ? "required" : ""}>
            <label class="field__label">${label}${["email","fullname","business_name"].includes(field) ? " *" : ""}</label>
          </div>`;
      }
    });
    form.innerHTML += `<button type="submit" class="button button--primary cta-submit-lead">Submit</button>`;

    // Attach submit handler
    form.onsubmit = async function(e) {
      e.preventDefault();
      message.textContent = "Submitting...";

      try {
        const fd = new FormData(form);

        // Always send backend-required fields (even if blank)
        if (!fd.has("city")) fd.append("city", "");
        if (!fd.has("address1")) fd.append("address1", "");
        if (!fd.has("country")) fd.append("country", "");

        fd.append("page_url", window.location.href);


        const response = await fetch("https://srklr.greenworkstools.com/submission/" + currentType + "/", {
          method: "POST",
          body: fd
        });

        console.log("Raw response:", response);

        const result = await response.json().catch(err => {
          console.error("JSON parse error:", err);
          throw new Error("Response not JSON. Status: " + response.status);
        });

        message.textContent = result.message || (result.status === "ok" ? "Success!" : "Error");
        if (result.status === "ok") form.reset();
      } catch (err) {
        console.error("Submit error:", err);
        message.textContent = "Something went wrong.";
      }
    };
  }
});

// Footer Semi-Awareness
document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("ContactFooter");

  if (form) {
    form.addEventListener("submit", function (e) {
      const emailInput = form.querySelector("input[name='contact[email]']");
      if (!emailInput || !emailInput.value) return; // skip if no email

      const fd = new FormData();
      fd.append("email", emailInput.value);
      fd.append("city", "Unknown");
      fd.append("address1", "Unknown");    
      fd.append("country", "US");

      // Fire-and-forget: don't block Shopify form submission
      navigator.sendBeacon("https://srklr.greenworkstools.com/submission/awarenessform/", fd);
    });
  }
});
